import { lazy } from "react";

export { DYNAMIC_ATTRIBUTE_EDITOR_PATH } from "./editor/dynamic-attribute-editor-page-path";

export const DynamicAttributeEditorPage = lazy(
  () => import("./editor/dynamic-attribute-editor-page"),
);
